import { Link } from 'react-router-dom';
import { AlertRow, InsightsAlerts } from '../../types/marketing';
import DataTable, { DataTableColumn } from './DataTable';
import { formatAed, formatLongDay } from './marketingMath';

const TYPE_LABELS: Record<string, string> = { ZERO_RESULT: 'Spend with no taps', COST_PER_SIGNUP: 'Cost per sign-up too high' };

const COLUMNS: DataTableColumn<AlertRow>[] = [
  { key: 'day', header: 'Day', accessor: (r) => r.day, format: 'text' },
  { key: 'type', header: 'Alert', accessor: (r) => TYPE_LABELS[r.type] ?? r.type, format: 'text' },
  { key: 'campaign', header: 'Campaign', accessor: (r) => r.name || r.campaignKey || 'All campaigns', format: 'text' },
  { key: 'value', header: 'Value', accessor: (r) => r.value, format: 'aed' },
  { key: 'threshold', header: 'Threshold', accessor: (r) => r.threshold, format: 'aed' },
  { key: 'message', header: 'Message', accessor: (r) => r.message, format: 'text' },
  { key: 'notified', header: 'Telegram', accessor: (r) => (r.notified ? 'Sent' : 'Not sent'), format: 'text' },
];

/** Spec 084 Alerts tab — the last 30 days of alerts and the thresholds that raise them (Runtime Config). */
export default function AlertsSection({ data, range }: { data: InsightsAlerts; range: { from: string; to: string; timezone: string } }) {
  const t = data.thresholds;
  return (
    <div className="mkt-section" data-testid="section-alerts">
      <section className="mkt-card">
        <div className="mkt-thresholds" data-testid="alerts-thresholds">
          <p><b>Spend with no taps:</b> {t.zeroResultDays > 0 ? `a campaign spends on ${t.zeroResultDays} days in a row with 0 store taps` : 'off'}</p>
          <p><b>Cost per sign-up:</b> {t.maxCostPerSignUpAed && t.maxCostPerSignUpAed > 0 ? `blended over 7 days above ${formatAed(t.maxCostPerSignUpAed)}` : 'off'}</p>
          <p className="mkt-foot">Change the thresholds in <Link to="/dynamic-config" data-testid="alerts-config-link">Configuration → Runtime Config</Link> (garagat.marketing.alert.zero-result-days, garagat.marketing.alert.max-cost-per-signup-aed). 0 turns an alert off.</p>
        </div>
        <DataTable caption="Alerts, last 30 days" columns={COLUMNS} rows={data.alerts} rowKey={(r) => `${r.day}|${r.type}|${r.campaignKey ?? ''}`}
          defaultSort={{ key: 'day', dir: 'desc' }} emptyText="No alerts in the last 30 days" exportMeta={range} testId="alerts-table" />
        {data.alerts.length > 0 && <p className="mkt-foot">Latest alert: {formatLongDay(data.alerts[0].day)} (Dubai).</p>}
      </section>
    </div>
  );
}
